class ClipUtils {
  static shortenTitle(text) {
    const maxLength = 85; // maximum number of characters to extract
    const tolerance = 5; // pour éviter de mettre "..." au lieu d'un mot de 3 lettres
    if (text.length < maxLength + tolerance) {
      return text;
    }
    //trim the string to the maximum length
    let trimmedString = text.substr(0, maxLength);
    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(
      0,
      Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
    );
    return trimmedString + " ...";
  }

  static computeUrl(sentence, id) {
    const max_length = 100;
    let title = sentence.replace(/[^a-zA-Z0-9\u00C0-\u00FF]+/g, "-"); // remplace les caractères spéciaux par des "-"
    title = title.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Supprime les accents
    if (title.length > max_length) {
      title = title.substring(0, max_length); // Limite la taille à 100
      const positionLastDash = title.lastIndexOf("-");
      title = title.substring(0, positionLastDash); // Coupe à la fin d'un mot
    }
    title = title.replace(/-+$/, ""); // Supprime l'éventuel "-" final
    return "/replique/" + title + "_" + id;
  }
}

export default ClipUtils;



// WEBPACK FOOTER //
// ./src/utils/ClipUtils.js